import { fillString } from '@local_modules/generic/string-template.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'

import htmlTemplateIndex from './index.html'
import { showTableEntities } from './show-table.js'

import { checkPageRestriction } from '../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../helpers/restrictions/apply-html-restrictions.js'

/**
 *
 * @param {Object} params
 * @param {String} params.containerElementId
 * @param {Object} params.browserAppUser
 * @param {Object} params.browserAppAccount
 *
 * @returns
 */
export async function showPageEntitiesPG (params) {
  console.log('showPageEntitiesPG')

  const { containerElementId, browserAppUser, browserAppAccount } = params

  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  document.getElementById(containerElementId)?.classList.add('position-absolute')
  document.getElementById(containerElementId)?.classList.add('top-to-bottom')

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  // Set page title
  document.title = ['Group Entities:', browserAppAccount.data.appAccount.name].join(' ')

  // Load entities from the page, ensuring it is latest data
  await browserAppAccount.refreshEntities()

  showTableEntities(browserAppAccount)
}
